
/* Sort select submits by navigating, so the choice survives filters and
   pagination. No JS on the page still leaves a usable (if manual) form. */
(function () {
  'use strict';
  function init() {
    var sel = document.querySelector('[data-sort-select]');
    if (!sel) return;
    sel.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sel.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
})();
